<template>
  <div>
    <div class="table-responsive col-lg-12">
      <table class="table table-striped table-bordered table-hover">
        <thead>
        <tr>
          <th>Brand</th>
          <th>Outclicks</th>
          <th>Outclicks 30 Days</th>
          <th>Markets</th>
          <th>Aff Links</th>
          <th>Status</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="brand in brands" :key="brand.id" >
          <td>
            <router-link :to="'/advertisers/brand/' + brand.id" >{{ brand.brand }}</router-link>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td>{{ brand.status }}</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      brands: 'getBrands'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Advertisers/Brands/List.vue